<template>
  <div class="modal-content">
    <div class="modal-body">
      <customer-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import CustomerDetails from '~/components/CustomerDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (customer) {
      this.$emit('save', customer)
    }
  },
  components: {
    CustomerDetails
  }
}

</script>